import { ACTIVATE_USER, ACTIVATE_USER_DONE, ACTIVATE_USER_ERR, RESET_USER_ACTIVATION } from './actionTypes';
export const activateUser = (data) => ({
    type: ACTIVATE_USER,
    data
});
export const doneActivatingUser = () => ({
    type: ACTIVATE_USER_DONE
});
export const errorActivatingUser = (data) => ({
    type: ACTIVATE_USER_ERR,
    errorMessage: data
});
export const resetUserActivation = () => ({
    type: RESET_USER_ACTIVATION
});
//# sourceMappingURL=actionCreators.js.map